import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

interface MoneyProps {
  amount: string | number;
}

const Money = ({ amount }: MoneyProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>{`${amount} ${t(
      "lbl_saudi_currency"
    )}`}</div>
  );
};

export default Money;
